import { 
  EuiFlexGroup,
  EuiFlexItem,
  EuiPage,
  EuiPageBody,
  EuiPageContent,
  EuiPageContentBody,
  EuiPageContentHeader,
  EuiPageContentHeaderSection,
  EuiPageHeader,
  EuiPageHeaderSection,
  EuiTitle,} from '@elastic/eui';
import React from 'react';
import { PanelInfoBloqueoApp } from '../../components/Layout/PanelInformativoBloqueo';
import PartesContainer from './container';

export const ValidacionesScreen = (props) =>{
  return (
    <EuiPage>
    <EuiPageBody component="div">
      <EuiPageHeader>
      <EuiFlexGroup>
          <EuiFlexItem>
            <EuiTitle size="l">
              <h1>{`VALIDACIÓN DE PARTES`}</h1>
            </EuiTitle>
          </EuiFlexItem>
          <EuiFlexItem grow={false}><PanelInfoBloqueoApp validacion/></EuiFlexItem>
        </EuiFlexGroup>
      </EuiPageHeader>
      <EuiPageContent>
        <EuiPageContentBody>
          <PartesContainer location={props.location}/>
        </EuiPageContentBody>
      </EuiPageContent>
    </EuiPageBody>
  </EuiPage>
  )
}
export default ValidacionesScreen;